import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { DataService_ReminderAlertSetup } from "../../shared/data.service";
import { StationReminderAlertUpdateRequest } from "../../shared/StationReminderAlertUpdateRequest";
import * as moment from "moment";

@Component({
	selector: "app-scan-reminder-edit",
	templateUrl: "./scan-reminder-edit.component.html",
	styleUrls: ["./scan-reminder-edit.component.css"],
})
export class ScanReminderEditComponent implements OnInit {
	constructor(
		private userService: UserService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private reminderService: DataService_ReminderAlertSetup
	) {}

	ngOnInit(): void {
		this.StationReminderAlertID = this.dialogConfig.data.StationReminderAlertID;

		// console.log(this.dialogConfig.data);

		this.ScanExists = this.dialogConfig.data.ScanExists;

		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.selectedGroupValue = this.SchoolID > 0 ? 2 : 1;
		this.Messagecolor = this.dialogConfig.data.MessageFontColor;
		this.Message = this.dialogConfig.data.Message;
		this.SelectedAlertTypeID = Number(this.dialogConfig.data.AlertType);

		this.StartDate = new Date(this.dialogConfig.data.StartDate);
		this.EndDate = new Date(this.dialogConfig.data.EndDate);

		if (this.StartDate.getFullYear() < 2000) {
			this.StartDate = new Date();
		}
		if (this.EndDate.getFullYear() < 2000) {
			this.EndDate = new Date();
		}

		this.Priority = this.dialogConfig.data.Priority;
		this.EntryMode = this.dialogConfig.data.EntryMode;
		this.ExitMode = this.dialogConfig.data.ExitMode;
		this.MealMode = this.dialogConfig.data.MealMode;
		this.AccessMode = this.dialogConfig.data.AccessMode;
		this.TimeStampMode = this.dialogConfig.data.TimeStampMode;
		this.EventEntryMode = this.dialogConfig.data.EventEntryMode;
		this.EventExitMode = this.dialogConfig.data.EventExitMode;

		this.SoundLibraryID = this.dialogConfig.data.SoundLibraryID;
		this.StudentCount = this.dialogConfig.data.StudentCount;

		this.ParentPortalSendNotification = this.dialogConfig.data.ParentPortalSendNotification;
		this.StudentPortalSendNotification = this.dialogConfig.data.StudentPortalSendNotification;
		this.StaffPortalSendNotification = this.dialogConfig.data.StaffPortalSendNotification;

		this.loadSound();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	ScanExists: boolean = true;

	selectedGroupValue: number = 2; //1 All Schools, 2 Selected School

	Messagecolor: any = "#000000";
	Message: string = "";

	SelectedSound: any;
	lstSoundItems: any = [];

	SelectedAlertTypeID: number = 1;
	lstAlertType: any = [
		{
			ID: 1,
			Desc: "Play Once",
		},
		{
			ID: 2,
			Desc: "Play Until Removed",
		},
		{
			ID: 3,
			Desc: "Play in Date Range",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	Priority: number = 2;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];

	EntryMode: boolean = true;
	ExitMode: boolean = true;
	MealMode: boolean = true;
	AccessMode: boolean = true;
	TimeStampMode: boolean = true;
	EventEntryMode: boolean = true;
	EventExitMode: boolean = true;

	ParentPortalSendNotification: boolean = false;
	StudentPortalSendNotification: boolean = false;
	StaffPortalSendNotification: boolean = false;

	loading: boolean = false;
	Processing: boolean = false;

	audio: any = new Audio();

	errorMessage: string = "";

	SchoolID: any = -1;
	SoundLibraryID: any;
	StudentCount: any;
	StationReminderAlertID: any;

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadSound() {
		this.loading = true;

		var result = this.reminderService.LoadSoundPopupList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSoundItems = response;

				this.lstSoundItems.unshift({
					SoundLibraryID: -1,
					SoundFile: "None",
					SoundData: null,
				});

				this.SelectedSound = this.lstSoundItems[0];

				for (var z = 0; z < this.lstSoundItems.length; z++) {
					var next = this.lstSoundItems[z];

					if (next.SoundLibraryID == this.SoundLibraryID) {
						this.SelectedSound = next;
						break;
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		var fsDate: string = "";
		var feDate: string = "";

		if (this.SelectedAlertTypeID == 3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Start Date";
				return;
			}
			if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid End Date";
				return;
			}
		}

		//
		// Reset student entries?
		//
		if (this.StudentCount > 0) {
			this.confirmationService.confirm({
				key: "editconfirm",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message:
					"Do you want to resend the reminder to students who already received it? This will reset whether or not it was already played for each student.",
				header: "Reset Already Played",
				icon: "fa",
				accept: () => {
					this.FinishAdd(fsDate, feDate, true);
				},
				reject: () => {
					this.FinishAdd(fsDate, feDate, false);
				},
			});
		} else {
			this.FinishAdd(fsDate, feDate, false);
		}
	}

	FinishAdd(fsDate, feDate, reset) {
		//
		// Create Parms
		//

		this.Processing = true;

		var parms: StationReminderAlertUpdateRequest = {
			StationReminderAlertID: this.StationReminderAlertID,
			Message: this.Message,
			AlertType: this.SelectedAlertTypeID,
			MessageFontColor: this.Messagecolor,
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			StartDate: fsDate,
			EndDate: feDate,
			Priority: this.Priority,
			EntryMode: this.EntryMode == true ? 1 : 0,
			ExitMode: this.ExitMode == true ? 1 : 0,
			MealMode: this.MealMode == true ? 1 : 0,
			AccessMode: this.AccessMode == true ? 1 : 0,
			TimeStampMode: this.TimeStampMode == true ? 1 : 0,
			EventEntryMode: this.EventEntryMode == true ? 1 : 0,
			EventExitMode: this.EventExitMode == true ? 1 : 0,
			ParentPortalSendNotification: this.ParentPortalSendNotification == true ? 1 : 0,
			StudentPortalSendNotification: this.StudentPortalSendNotification == true ? 1 : 0,
			StaffPortalSendNotification: this.StaffPortalSendNotification == true ? 1 : 0,
			ResetAlreadyPlayed: reset == true ? 1 : 0,
		};

		var result = this.reminderService.StationReminderAlertUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Reminder was Updated Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Reminder",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	onPlay() {
		this.errorMessage = "";

		if (this.SelectedSound == null || this.SelectedSound.SoundData == null) {
			this.errorMessage = "Select a sound to play";
			return;
		}

		this.audio.src = this.SelectedSound.SoundData;
		this.audio.load();
		this.audio.play();
	}

	onStop() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	//Events
	/////////////////////////////////////////////////////////////////////
	onSoundChange(val) {
		this.SelectedSound = val;

		this.onStop();
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.Processing == true;
	}
	/////////////////////////////////////////////////////////////////////
}
